import { Injectable } from '@angular/core';
import {
  AbstractControlOptions,
  UntypedFormArray,
  Validators,
} from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import { Profession } from '@app/forms/subscription/definition/interface/subscription';
import moment from 'moment';
import { Parameters } from '../../definition/interface/Pledge';
import { CompanyFieldType } from '../../definition/interface/enum';
import FormGroupArray from '../../services/FormGroupArray';
@Injectable({
  providedIn: 'root',
})
export abstract class EaSubscriptionBuilder extends PrFormAbstract {
  generateForm(entity: Profession, option) {
    let options: AbstractControlOptions = {};
    const organizationId = option.organizationId;
    let swisslifeActivitySectorLcbFtValidation =
      this.swisslifeActivitySectorLcbFtRequired(option?.pledgeParameters || {});

    return this.formBuilder.group(
      {
        ownerId: [entity.ownerId],
        userFirstName: [entity.userFirstName],
        userLastName: [entity.userLastName],
        professionLabel: [entity?.professionLabel || null, Validators.required],
        professionGroup: [entity?.professionGroup || null, Validators.required],
        professionSituation: [
          entity?.professionSituation || null,
          Validators.required,
        ],
        professionActivitySector: [
          entity?.professionActivitySector || null,
          swisslifeActivitySectorLcbFtValidation
            ? Validators.nullValidator
            : Validators.required,
        ],
        professionCategory: [
          entity?.professionCategory || null,
          Validators.required,
        ],
        professionStartDate: [
          entity?.professionStartDate || calculateDateSubtractYears(),
          Validators.required,
        ],
        professionWorkInPublic: [
          entity?.professionWorkInPublic || false,
          entity?.professionSituation !== null &&
          entity?.professionSituation === 'SALARIED'
            ? Validators.required
            : null,
        ],
        swisslifeActivitySectorLcbFt: [
          entity?.swisslifeActivitySectorLcbFt || null,
          swisslifeActivitySectorLcbFtValidation
            ? Validators.required
            : Validators.nullValidator,
        ],
        swisslifeActivitySectorLcbFtOther: [
          entity?.swisslifeActivitySectorLcbFtOther || null,
          swisslifeActivitySectorLcbFtValidation &&
          entity?.swisslifeActivitySectorLcbFt === 'AUTRE'
            ? Validators.required
            : Validators.nullValidator,
        ],
      },
      options,
    );
  }

  generate(entity: Profession[], option) {
    return FormGroupArray.generate({
      entity,
      options: option,
      formBuilder: this.formBuilder,
      generateForm: this.generateForm.bind(this),
    });
  }

  get owners() {
    return this.form.get('owners') as UntypedFormArray;
  }

  swisslifeActivitySectorLcbFtRequired(parameters: Parameters) {
    return (
      this.getAdditionalQuestions(
        parameters,
        CompanyFieldType.SWISSLIFE_ACTIVITY_SECTOR_LCB_FT,
      )?.required === 'MANDATORY' || false
    );
  }

  getAdditionalQuestions(parameters: Parameters, type: any) {
    return parameters?.additionalQuestions?.find(q => q?.id === type);
  }

  extract() {
    const policeWord = [
      'GENDARME',
      'OFFICIER',
      'FLIC',
      'POLICIER',
      'POLICE',
      'FLICARD',
      'LIMIER',
      'MILITAIRE',
      'LIEUTENANT',
      'armée',
    ];
    const owners = this.form.value.owners;
    const policeWordArray = policeWord.map(word => word.toLowerCase());

    for (const owner of owners) {
      if (owner?.professionActivitySector === 'null') {
        owner.professionActivitySector = null;
      }
      const labelArray = owner.professionLabel.toLowerCase().split(' ');
      for (const word of labelArray) {
        if (policeWordArray.includes(word)) {
          owner.professionLabel = 'fonctionnaire';
        }
      }
    }

    return owners;
  }
}
// export function calculateDateSubtractYears(date: Date=new Date()): Date {
//   return moment(date).subtract(2, "year").toDate();
// }
export function calculateDateSubtractYears(date: Date = new Date()): Date {
  const subtractedDate = moment(date).subtract(2, 'year').toDate();
  subtractedDate.setMonth(0); // Set the month to January (0-indexed).
  subtractedDate.setDate(1); // Set the day to 1st.
  return subtractedDate;
}
